{
  "allTasks.nav": "All tasks",
  "allTasks.title": "All tasks",
  "allTasks.subtitle": "Every project's work on one board. Narrow it with the filters.",
  "allTasks.loadError": "We could not load the tasks.",
  "allTasks.empty.title": "No tasks yet",
  "allTasks.empty.body": "Tasks added to any project show up here.",
  "allTasks.capped": "Showing the first {count} tasks. Narrow the filters to see the rest.",
  "allTasks.quick.label": "Quick views",
  "allTasks.quick.mine": "My tasks",
  "allTasks.quick.unassigned": "Unassigned",
  "allTasks.quick.overdue": "Overdue",
  "allTasks.quick.week": "Due this week",
  "allTasks.quick.blocked": "Blocked",
  "allTasks.filters.label": "Filters",
  "allTasks.filters.project": "Project",
  "allTasks.filters.projectSearch": "Search projects",
  "allTasks.filters.client": "Client",
  "allTasks.filters.clientSearch": "Search clients",
  "allTasks.filters.internal": "Internal projects",
  "allTasks.filters.assignee": "Assignee",
  "allTasks.filters.priority": "Priority",
  "allTasks.filters.prioritySearch": "Search priorities",
  "allTasks.filters.due": "Due",
  "allTasks.filters.labels": "Labels",
  "allTasks.filters.noMatch": "Nothing matches.",
  "allTasks.filters.selected": "{count, plural, one {# selected} other {# selected}}",
  "allTasks.filters.clear": "Clear",
  "allTasks.filters.clearOne": "Clear {filter}",
  "allTasks.filters.clearAll": "Clear all",
  "allTasks.due.overdue": "Overdue",
  "allTasks.due.today": "Today",
  "allTasks.due.week": "This week",
  "allTasks.due.next7": "Next 7 days",
  "allTasks.due.none": "No due date",
  "allTasks.due.custom": "Custom range",
  "work.you": "You",
  "work.searchPeople": "Search people",
  "work.noPeopleMatch": "No one matches.",
  "work.notSet": "Not set",
  "health.status.on_track": "On track",
  "health.status.at_risk": "At risk",
  "health.status.off_track": "Off track",
  "health.status.paused": "Paused",
  "health.finding.past_due": "Past its end date by {count, plural, one {# day} other {# days}}",
  "health.finding.due_soon": "Ends {count, plural, =0 {today} one {tomorrow} other {in # days}} with most work still open",
  "health.finding.overdue_tasks": "{count, plural, one {# task is overdue} other {# tasks are overdue}}",
  "health.finding.stale": "Nothing moved for {count, plural, one {# day} other {# days}}",
  "health.finding.late_milestones": "{count, plural, one {# milestone is late} other {# milestones are late}}",
  "projects.internal": "Internal",
  "projects.noLead": "No lead",
  "projects.columns.lead": "Lead",
  "projects.columns.health": "Health",
  "projects.columns.overdue": "Overdue",
  "projects.statusFilter.label": "Filter by status",
  "projects.statusFilter.open": "Open",
  "projects.statusFilter.on_hold": "On hold",
  "projects.statusFilter.completed": "Completed",
  "projects.statusFilter.archived": "Archived",
  "projects.statusFilter.all": "All",
  "projects.filter.allServices": "All services",
  "projects.filter.option": "{label} ({count})",
  "projects.filter.client": "Filter by client",
  "projects.filter.allClients": "All clients",
  "projects.filter.clientSearch": "Search clients",
  "projects.filter.clientEmpty": "No client matches.",
  "projects.emptyMember.title": "You have not been added to a project yet",
  "projects.emptyMember.body": "When a project lead adds you to a project, it will show up here.",
  "projects.emptyStatus.on_hold": "No projects are on hold",
  "projects.emptyStatus.completed": "No completed projects yet",
  "projects.emptyStatus.archived": "Nothing is archived",
  "projects.emptyStatus.all": "No projects yet",
  "projects.emptyStatus.body": "Projects show up here when their status changes.",
  "projects.stats.overdue": "Overdue tasks",
  "projects.stats.attention": "{count, plural, =0 {All on track} one {# needs attention} other {# need attention}}",
  "newProject.client": "Client",
  "newProject.noClient": "No client (internal)",
  "newProject.clientSearch": "Search clients",
  "newProject.clientEmpty": "No client matches.",
  "newProject.lead": "Lead",
  "newProject.leadPlaceholder": "Choose a lead",
  "newProject.startsOn": "Start date",
  "newProject.dueOn": "End date",
  "newProject.descriptionLabel": "Description",
  "newProject.descriptionPlaceholder": "What is this project about? Goals, scope, useful links.",
  "newProject.errors.dueBeforeStart": "The end date cannot be before the start date.",
  "project.internal": "Internal project",
  "project.schedule": "Schedule",
  "project.dates": "{start} – {end}",
  "project.dueOn": "Due {date}",
  "project.startsOn": "Starts {date}",
  "project.tabs.list": "List",
  "project.tabs.members": "Members",
  "project.tabs.settings": "Settings",
  "project.archived.title": "This project is archived",
  "project.archived.body": "It is read-only. Ask the project lead if it needs to come back.",
  "project.archived.bodyManager": "It is read-only. Restore it to plan and edit tasks again.",
  "project.archived.restore": "Restore project",
  "project.archived.restored": "The project was restored.",
  "projectRole.lead": "Lead",
  "projectRole.contributor": "Contributor",
  "projectRole.viewer": "Viewer",
  "overview.health.title": "Health",
  "overview.health.onTrack": "Everything is on track.",
  "overview.health.paused": "The project is on hold, so its health is paused.",
  "overview.health.closed": "Health is tracked while a project is active.",
  "overview.health.completedOn": "Completed on {date}.",
  "overview.members.title": "Members",
  "overview.members.manage": "Manage",
  "overview.members.all": "View all",
  "overview.members.openTasks": "{count, plural, =0 {No open tasks} one {# open task} other {# open tasks}}",
  "overview.members.more": "{count, plural, one {# more member} other {# more members}}",
  "members.loadError": "We could not load the members.",
  "members.description": "Leads manage the project and its people. Contributors plan and do the work. Viewers follow along.",
  "members.readOnly": "Only the project lead and admins can change who is on the project.",
  "members.add": "Add member",
  "members.adding": "Adding…",
  "members.addPerson": "Person to add",
  "members.addPlaceholder": "Choose a team member",
  "members.addNobody": "Everyone on the team is already on this project.",
  "members.addRole": "Project role",
  "members.added": "{name} was added to the project.",
  "members.roleOf": "Project role of {name}",
  "members.roleChanged": "Role updated for {name}.",
  "members.youAndRole": "You · {role}",
  "members.leadHint": "To hand over the lead, make another member the lead.",
  "members.remove": "Remove {name}",
  "members.removeTitle": "Remove {name} from the project?",
  "members.removeBody": "{count, plural, =0 {They have no open tasks here.} one {Their # open task will be unassigned.} other {Their # open tasks will be unassigned.}} They can be added back at any time.",
  "members.removeConfirm": "Remove",
  "members.removing": "Removing…",
  "members.removed": "{name} was removed. {count, plural, =0 {No tasks needed reassigning.} one {# task is now unassigned.} other {# tasks are now unassigned.}}",
  "members.makeLeadTitle": "Make {name} the project lead?",
  "members.makeLeadBody": "{previous} becomes a contributor. The lead manages the project, its members and its settings.",
  "members.makeLeadConfirm": "Make lead",
  "members.errors.alreadyMember": "This person is already on the project.",
  "members.errors.lastLead": "A project needs a lead. Make someone else the lead first.",
  "members.errors.notStaff": "Only active team members can join a project.",
  "settings.details.title": "Project details",
  "settings.save": "Save changes",
  "settings.saving": "Saving…",
  "settings.saved": "Changes saved.",
  "settings.discard": "Discard",
  "settings.conflict.title": "Someone else changed this project",
  "settings.conflict.body": "Load their changes, then make yours again.",
  "settings.conflict.reload": "Load latest",
  "settings.errors.archived": "Archived projects cannot be edited. Restore the project first.",
  "settings.errors.transition": "That change is not possible from the current status.",
  "settings.status.title": "Status",
  "settings.status.about.active": "Work is under way and its health is tracked.",
  "settings.status.about.on_hold": "Paused. Health is not tracked until it resumes.",
  "settings.status.about.completed": "Delivered. Reopen it if more work comes in.",
  "settings.status.about.archived": "Hidden from the projects list and read-only.",
  "settings.action.hold": "Put on hold",
  "settings.action.resume": "Resume",
  "settings.action.complete": "Mark completed",
  "settings.action.reopen": "Reopen",
  "settings.action.archive": "Archive",
  "settings.action.restore": "Restore",
  "settings.confirm.archive.title": "Archive {name}?",
  "settings.confirm.archive.body": "It leaves the projects list and becomes read-only. You can restore it at any time.",
  "settings.confirm.archive.confirm": "Archive project",
  "settings.confirm.complete.title": "Mark {name} as completed?",
  "settings.confirm.complete.body": "Its health stops being tracked. Open tasks stay as they are, and you can reopen the project later.",
  "settings.confirm.complete.confirm": "Mark completed",
  "settings.statusChanged": "Status changed to {status}.",
  "settings.forbidden.title": "Only the lead and admins can change settings",
  "settings.forbidden.body": "Ask the project lead if something needs to change.",
  "board.collapse": "Collapse {column}",
  "board.expand": "Expand {column}",
  "board.done.olderHidden": "{count, plural, one {# task} other {# tasks}} done more than {days, number} days ago",
  "board.done.showAll": "Show all in list",
  "board.addError.generic": "The task was not added. Try again.",
  "board.addError.archived": "This project is archived, so tasks cannot be added.",
  "priority.none": "No priority",
  "priority.low": "Low",
  "priority.medium": "Medium",
  "priority.high": "High",
  "priority.urgent": "Urgent",
  "priority.label": "Priority: {priority}",
  "task.assignedTo": "Assigned to {name}",
  "task.due.label": "Due {date}",
  "task.due.overdueLabel": "Overdue, was due {date}",
  "task.due.overdue": "Overdue",
  "task.due.today": "Today",
  "task.due.tomorrow": "Tomorrow",
  "task.due.yesterday": "Yesterday",
  "task.description": "Description",
  "task.descriptionPlaceholder": "Add a description…",
  "task.descriptionEmpty": "No description.",
  "task.editDescription": "Edit description",
  "task.assignee": "Assignee",
  "task.unassigned": "Unassigned",
  "task.assigneeSearch": "Search members",
  "task.assignees": "Assignees",
  "task.editAssignees": "Change assignees",
  "task.assigneesFull": "A task takes up to {count, number} people.",
  "task.moreAssignees": "+{count, number}",
  "task.priority": "Priority",
  "task.startsOn": "Start date",
  "task.dueOn": "Due date",
  "task.clearDate": "Clear {field}",
  "task.estimate": "Estimate",
  "task.estimateHours": "Hours",
  "task.estimateMinutes": "Minutes",
  "task.estimateHoursUnit": "h",
  "task.estimateMinutesUnit": "min",
  "task.estimateValue": "{hours, number} h {minutes, number} min",
  "task.estimateHoursOnly": "{hours, number} h",
  "task.estimateMinutesOnly": "{minutes, number} min",
  "task.noEstimate": "No estimate",
  "task.createdBy": "Created by",
  "task.loadError": "We could not load this task.",
  "task.cancelledNotice": "This task was cancelled. It is kept for the record and stays off the board.",
  "task.readOnly": "You can view this task but not change it.",
  "task.archivedProject": "This project is archived, so its tasks are read-only.",
  "task.cancel.action": "Cancel task",
  "task.cancel.title": "Cancel {reference}?",
  "task.cancel.body": "It leaves the board and no longer counts toward progress. You can restore it later from the list.",
  "task.cancel.confirm": "Cancel task",
  "task.cancel.keep": "Keep task",
  "task.cancel.done": "{reference} was cancelled.",
  "task.restore.action": "Restore task",
  "task.restore.title": "Restore {reference}?",
  "task.restore.body": "It goes back to the end of To do.",
  "task.restore.confirm": "Restore task",
  "task.restore.done": "{reference} was restored.",
  "taskList.columns.status": "Status",
  "taskList.columns.reference": "ID",
  "taskList.columns.title": "Title",
  "taskList.columns.assignee": "Assignee",
  "taskList.columns.priority": "Priority",
  "taskList.columns.due": "Due",
  "taskList.columns.updated": "Updated",
  "taskList.sortBy": "Sort by {column}",
  "taskList.sort.label": "Sort",
  "taskList.sort.updated": "Recently updated",
  "taskList.sort.due": "Due date",
  "taskList.sort.priority": "Priority",
  "taskList.sort.created": "Newest",
  "taskList.sort.number": "ID",
  "taskList.filters.search": "Search tasks",
  "taskList.filters.status": "Filter by status",
  "taskList.filters.assignee": "Filter by assignee",
  "taskList.filters.anyone": "Anyone",
  "taskList.filters.me": "Me",
  "taskList.filters.priority": "Filter by priority",
  "taskList.filters.anyPriority": "Any priority",
  "taskList.filters.due": "Due",
  "taskList.filters.dueAfter": "Due from",
  "taskList.filters.dueBefore": "Due until",
  "taskList.filters.clear": "Clear filters",
  "taskList.count": "{count, plural, one {# task} other {# tasks}}",
  "taskList.loadMore": "Load more",
  "taskList.loadingMore": "Loading…",
  "taskList.empty.title": "No tasks yet",
  "taskList.empty.body": "Tasks added on the board show up here.",
  "taskList.noResults.title": "No matching tasks",
  "taskList.noResults.body": "Try other filters, or clear them to see every task.",
  "taskList.loadError": "We could not load the tasks.",
  "taskList.noDate": "—",
  "projects.view.label": "Show projects as",
  "projects.view.list": "List",
  "projects.view.grid": "Cards",
  "projects.columns.dates": "Timeline",
  "projects.columns.tasks": "Tasks",
  "projects.tasks.open": "{count, plural, =0 {No open tasks} one {# open} other {# open}}",
  "projects.tasks.overdue": "{count, plural, one {# overdue} other {# overdue}}",
  "projects.dates.noEnd": "No end date",
  "projects.dates.ends": "Ends {date}",
  "projects.members": "{count, plural, one {# member} other {# members}}",
  "projects.stats.attentionNone": "All on track",
  "project.pulse.label": "Project at a glance",
  "project.pulse.done": "done",
  "project.pulse.open": "{count, plural, one {open task} other {open tasks}}",
  "project.pulse.daysLeft": "{count, plural, one {day left} other {days left}}",
  "project.pulse.daysLate": "{count, plural, one {day late} other {days late}}",
  "board.column.empty": "No tasks here",
  "board.column.dropHere": "Drop a task here, or add one",
  "overview.health.check.past_due": "Within its end date",
  "overview.health.check.due_soon": "Not ending with most work still open",
  "overview.health.check.overdue_tasks": "No overdue tasks",
  "overview.health.check.stale": "Work moved recently",
  "overview.health.check.late_milestones": "No late milestones",
  "members.roles.title": "Roles on this project",
  "members.roles.lead": "Runs the project: its people, plan and settings.",
  "members.roles.contributor": "Plans and does the work: tasks, files and time.",
  "members.roles.viewer": "Follows along and comments, without changing work.",
  "members.roles.openWork": "{count, plural, =0 {No open tasks assigned} one {# open task assigned across the team} other {# open tasks assigned across the team}}",
  "task.placement.label": "In plan",
  "task.placement.projectOnly": "Project only (no milestone)",
  "task.placement.search": "Search milestones and phases",
  "task.placement.noMatch": "No milestone or phase matches.",
  "task.placement.path": "{milestone} › {phase}",
  "taskList.filters.phase": "Filter by phase",
  "taskList.filters.anyPhase": "Any phase",
  "taskList.filters.noPhase": "No phase",
  "taskList.filters.phaseSearch": "Search phases",
  "taskList.filters.noPhaseMatch": "No phase matches."
}
